import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RemoveHtmlTagPipe } from './pipe/RemoveHtmlTag.pipe';
import { decodeHtmlPipe } from './pipe/decodeHtml.pipe';
import { SafeHtmlPipe } from './pipe/SafeHtmlPipe.pipe';
import { SafeUrlPipe } from './pipe/SafeUrlPipe.pipe';
import { DataFilterPipe } from './pipe/data-filter.pipe';
import { DatexPipe } from './pipe/datexPipe.pipe';
import { DatepickerModule } from 'angular2-material-datepicker';
import { TinyComponent } from './../public/public.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    RemoveHtmlTagPipe,
    decodeHtmlPipe,
    SafeHtmlPipe,
    SafeUrlPipe,
    DataFilterPipe,
    DatexPipe,
    TinyComponent
  ],
  exports: [
    RemoveHtmlTagPipe,
    decodeHtmlPipe,
    SafeHtmlPipe,
    SafeUrlPipe,
    DataFilterPipe,
    DatePipe,
    DatexPipe,
    TinyComponent,
    DatepickerModule
  ],
  providers:[
    DatePipe,
    DatexPipe
  ]
})
export class PublicModule { }



// WEBPACK FOOTER //
// ./src/app/public/public.module.ts